/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxMinutes: NonNullable<unknown> }} Doc_Video_Duration_ExceededInputs */

const en_doc_video_duration_exceeded = /** @type {(inputs: Doc_Video_Duration_ExceededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This video is longer than the ${i?.maxMinutes}-minute analysis limit. It will be skipped, and the remaining files can still be processed.`)
};

const pt_br2_doc_video_duration_exceeded = /** @type {(inputs: Doc_Video_Duration_ExceededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este vídeo excede o limite de ${i?.maxMinutes} minutos para análise. Ele será ignorado, e os demais arquivos ainda poderão ser processados.`)
};

/**
* | output |
* | --- |
* | "This video is longer than the {maxMinutes}-minute analysis limit. It will be skipped, and the remaining files can still be processed." |
*
* @param {Doc_Video_Duration_ExceededInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_video_duration_exceeded = /** @type {((inputs: Doc_Video_Duration_ExceededInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Video_Duration_ExceededInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_video_duration_exceeded(inputs)
	return pt_br2_doc_video_duration_exceeded(inputs)
});